import { Injectable } from '@angular/core';
import { ActionModel } from '../Models/action-model';
import { ActionMocks } from '../DataStore/Mock/action-mocks';
import { Observable } from 'rxjs';
import { RestService } from './rest.service';

@Injectable({
  providedIn: 'root'
})
export class ActionServiceService {
  constructor(public rest:RestService) { }
  public findByObjectId(id: string):ActionModel{
    return ActionMocks.findByObjectId(id);
  }

  public findById(id:number):ActionModel{
      return ActionMocks.findById(id);
  }

 public getItems():Observable<ActionModel[]>{
    // return ActionMocks.getItems();
    return this.rest.get("commands",null);
  }
  
//  public getItems():ActionModel[]{
//      return ActionMocks.getItems();
//     // return this.rest.get("commands",null);

//   }
}